import { SuiteUserCustomization } from './../model/suite-user-customization';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const CONTROLLER = 'tenantCustomization';

@Injectable({
  providedIn: 'root',
})
export class TenantCustomizationService {
  public tenantTheme = new BehaviorSubject<string>('cdx-theme-green');
  public tenantLogo = new BehaviorSubject<string>(
    'assets/img/Logo_Satelitti.png'
  );
  public tenantIcon = new BehaviorSubject<string>('src\favicon.ico');

  constructor(private http: HttpClient) { }

  public getCustom(): Observable<SuiteUserCustomization | any> {
    const subDomain = location.hostname.split('.')[0].toLowerCase();
    return this.http.get(
      CONTROLLER.concat('/tenantCustomization?subDomain=' + subDomain)
    );
  }

  updateTenantCustom(suiteUserCustomization: SuiteUserCustomization) {
    if (!suiteUserCustomization) {
      return;
    }

    if (suiteUserCustomization.themeClass) {
      this.tenantTheme.next(suiteUserCustomization.themeClass);
    }

    if (suiteUserCustomization.logoPath) {
      this.tenantLogo.next(suiteUserCustomization.logoPath);
    }

    if (suiteUserCustomization.faviconPath) {
      this.tenantIcon.next(suiteUserCustomization.faviconPath);
    }
  }
}
